import axios from 'axios';
// config
import { API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: API.URL_FULL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
